import Base from '../base';

class AccountDeleteForm extends Base {
	start() {
		this.on('input', this.refs.password);
	}

	onInput(e) {
		const { target: { value: { length } } } = e;

		this.toggleSubmitButton(length > 0);
	}

	toggleSubmitButton(enabled) {
		this.refs.button.disabled = !enabled;
	}
}

export default AccountDeleteForm;
